var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000039835526939424746230000001260946749667145094_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1466.9 998.6",
    style: {
      enableBackground: "new 0 0 1466.9 998.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EC1A15;}\r\n\t.st1{fill:#F7F7F7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,119.2c26,24.6,51.9,49.1,77.9,73.8c22.3-23.5,44.5-46.9,66.9-70.5c-11.8-11-23.6-22-35.6-33.3 c-1.8,1.9-3.5,3.8-5.3,5.5c-8.8,8.9-17.6,17.7-26.4,26.5c-3.9,3.9-9.4,4.1-13,0.4c-3.6-3.6-3.4-9.1,0.5-13 c12.4-12.4,24.7-24.9,37.1-37.3c4.4-4.4,9.3-4.5,13.7-0.3c15.7,14.7,31.4,29.3,47.1,44c4.3,4,4.5,9.3,0.5,13.6 c-26.2,27.6-52.3,55.2-78.5,82.8c-3.7,3.9-9,4-13,0.2c-14.7-13.9-29.3-27.8-44-41.6C34.2,155.7,19.1,141.4,4,127 c-5.1-4.9-5.3-9.7-0.4-14.8c27.9-29.5,55.8-58.9,83.7-88.4c3.5-3.7,7-4.8,10.7-3.3c6,2.3,7.6,9.7,3.2,14.5c-8,8.5-16,17-24.1,25.5 C59,79.5,41,98.5,23,117.6C22.5,118,22.1,118.5,21.5,119.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.9,118c-26-24.6-51.8-49.1-77.9-73.8c-22.3,23.5-44.5,46.9-66.9,70.5c11.9,11.1,23.6,22,35.4,33.1 c0.6-0.5,1.1-1,1.5-1.5c10.1-10.2,20.2-20.4,30.4-30.5c4.3-4.3,10.8-3.8,14,1c2.4,3.5,2,8-1.1,11.3c-2.8,3-5.7,5.8-8.6,8.7 c-9.6,9.7-19.2,19.4-28.8,29c-4.4,4.4-9.3,4.5-13.9,0.2c-15.6-14.6-31.2-29.2-46.8-43.7c-4.6-4.3-4.8-9.4-0.4-14 c25.9-27.4,51.9-54.7,77.9-82.1c4.3-4.5,9.4-4.6,13.9-0.3c29.9,28.3,59.7,56.6,89.6,84.9c4.2,3.9,4.4,9.3,0.4,13.5 c-28.3,29.9-56.7,59.9-85,89.8c-3.8,4-9.3,4.3-13,0.8c-3.7-3.4-3.7-9.1,0.1-13c16.6-17.6,33.3-35.2,49.9-52.7 c9.4-9.9,18.8-19.9,28.2-29.8C207.1,119,207.4,118.6,207.9,118z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.1,224.2c0-6,4.8-10.8,10.7-10.8c5.9,0,10.7,4.8,10.7,10.8s-4.7,10.6-10.8,10.6 C110.7,234.8,106.1,230.2,106.1,224.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.1,10.8C100,4.8,104.8,0,110.8,0s10.8,4.7,10.8,10.7c0,5.9-4.7,10.6-10.6,10.7 C105,21.4,100.2,16.8,100.1,10.8z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1224.7,998.6H190.6C85.5,998.6,0.2,913.3,0.2,808.1V117.9h1276.6c105.2,0,190.4,85.2,190.4,190.4v447.8 C1467.2,890,1358.7,998.6,1224.7,998.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyBg);
export default __webpack_public_path__ + "static/media/emergency-bg.fd687661ca602a5c29a609eea6df417d.svg";
export { ForwardRef as ReactComponent };